import { Component, OnChanges, ChangeDetectionStrategy, input, output } from '@angular/core';
import {Sku} from '../../../model/sku';
import {SfrEntry} from '../../../model/sfr-entry';
import {IecLeadTime} from '../../../model/iec-lead-time';
import {SelectionUtils} from '../../../configurator/selection-utils';
import { CurrencyPipe } from '@angular/common';
import {LeadTimeRowComponent} from '../../../configurator/common/lead-time-row/lead-time-row.component';

@Component({
    selector: 'app-skus-and-pricing-section',
    templateUrl: './skus-and-pricing-section.component.html',
    styleUrls: ['./skus-and-pricing-section.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LeadTimeRowComponent, CurrencyPipe]
})
export class SkusAndPricingSectionComponent implements OnChanges {

  readonly messages = input.required<string[]>();
  readonly skus = input.required<Sku[]>();
  readonly sfrEntries = input.required<SfrEntry[]>();
  readonly entityLeadTime = input.required<IecLeadTime>();
  readonly configurationLeadTime = input.required<IecLeadTime>();
  readonly sfrFlagChanged = output<SfrEntry>();
  overriddenSlots: string[] = [];

  constructor() {
  }

  ngOnChanges(): void {
    this.loadOverriddenSlots();
  }

  getTotalPrice(): number {
    return SelectionUtils.getConfigurationPrice(this.skus(), this.sfrEntries());
  }

  getSfrPrice(sfrEntry: SfrEntry): number {
    return sfrEntry.ignore ? 0 : sfrEntry.price;
  }

  getSkuPrice(sku: Sku): number {
    return this.isOverridden(sku) ? 0 : sku.price;
  }

  isOverridden(sku: Sku): boolean {
    return this.overriddenSlots.indexOf(sku.name) >= 0;
  }

  ignoreFlagChanged(sfrEntry: SfrEntry): void {
    sfrEntry.ignore = !sfrEntry.ignore;
    this.loadOverriddenSlots();
    this.sfrFlagChanged.emit(sfrEntry);
  }


  private loadOverriddenSlots(): void {
    if (this.sfrEntries() && this.sfrEntries().length > 0) {
      this.overriddenSlots = this.sfrEntries().filter(sfr => !sfr.ignore).flatMap(sfr => sfr.skus);
    }
  }

}
